module.exports = __webpack_public_path__ + "854c8fcd7b0921567d56f8d0a78e122d.png";